import { useData, useDispatch } from "./DataContext.js";
import { getSimParam, setSimParam, computeDiffs } from "./utils.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import AmendmentCard from "./AmendmentCard.js";
import ButtonGrid from "./ButtonGrid.js";

export default function AmendmentPresentModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    let amendment = null;
    let amendmentType = null;
    let amendmentState = null;
    
    const amendmentID = getSimParam(gData, "presentAmendmentID");
    if (amendmentID !== null)
    {
	amendment = gData.amendment[amendmentID];
	amendmentType = amendment.type;
	amendmentState = amendment.state;
    }

    //if (! getSimParam(gData, "presentAmendment")) return (<></>);

    // ACTIONS
    function handleUnpresentAmendment () { setSimParam(gData, gDispatch, ["presentAmendment", "presentAmendmentID", "presentAmendmentState"], [false, null, null]); }
    function handleVoteAmendment () { setSimParam(gData, gDispatch, "presentAmendmentState", "vote"); }
    function handleUnvoteAmendment () { setSimParam(gData, gDispatch, "presentAmendmentState", "present"); }
    function handleResultAmendment () { setSimParam(gData, gDispatch, "presentAmendmentState", "result"); }

    /* 
     *     function handleNextAmendment ()
     *     {
     * 	const amendmentList = Object
     * 	    .entries(gData.amendment)
     * 	    .filter(([id, amendment]) => { return amendment.amendmentID !== amendmentID })
     * 	    .filter(([id, amendment]) => { return filterAmendmentState (gData, { simID: gData.simID, state: "submitted", displayAll: true, articleID: null }, amendment); })
     * 	    .sort(([id1, amendment1], [id2, amendment2]) => { return sortAmendmentState (gData, { state: "submitted" }, amendment1, amendment2); })
     * 	    .map(([id, amendment]) => amendment.amendmentID);
     * 
     * 	const nextAmendmentID = amendmentList.length > 0 ? amendmentList[0] : null;
     * 	if (nextAmendmentID !== null) setSimParam(gData, gDispatch, ["presentAmendment", "presentAmendmentID", "presentAmendmentState"], [true, nextAmendmentID, "present"]);
     *     } */

    function handleEndorseAmendment ()
    {
	const votes = Object
	    .entries(gData.vote)
	    .filter(([id, vote]) => { return vote.amendmentID === amendmentID; })
	    .map(([id, vote]) => vote);

	const voteCounts = votes.reduce((counts, vote) => { counts[vote.value] += vote.count; return counts; }, { "-1": 0, "0": 0, "1": 0 });
	const voteCount = voteCounts["-1"] + voteCounts["0"] + voteCounts["1"];

	const state = voteCounts["1"] > voteCount/2 ? "accepted" : "rejected";
	
	const lastAmendment = Object
	    .entries(gData.amendment)
	    .filter(([id, amendment2]) => {
		//const firstArticle2ID = amendment2.articleID === null ? null : gData.article[amendment2.articleID].firstArticleID;
		return amendment2.simID === gData.simID && (amendment2.state === "accepted" || amendment2.state === "rejected");
	    })
	    .reduce((amendment1, [id, amendment2]) => { if (amendment1 === null || amendment2.rank > amendment1.rank) return amendment2; else return amendment1; }, null);

	const rank = lastAmendment === null ? 0 : lastAmendment.rank+1;

	gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { state, rank } });
	// TODO: can be included in "accepted newArticle"

	if (state === "accepted")
	{
	    if (amendmentType === "newArticle")
	    {
		const lastArticle = Object
		    .entries(gData.article)
		    .filter(([id, article]) => {
			return article.simID === gData.simID
			    && article.sessionNum === 0
			    && article.type === "article"
			    && article.rank >= 0;
		    })
		    .reduce((article1, [id, article2]) => { if (article1 === null || article2.rank > article1.rank) return article2; else return article1; }, null);

		const amendmentID = amendment.amendmentID;
		const simID = amendment.simID;
		const sessionNum = amendment.sessionNum;
		const rank = lastArticle === null ? 0 : lastArticle.rank+1;
		const content = amendment.content;

		gDispatch({ type: "newArticle", data: { amendmentID, simID, sessionNum, rank, content } });
	    }

	    else if (amendmentType === "editArticle")
	    {
		const article = gData.article[amendment.articleID];
		const prevArticle = gData.article[amendment.prevArticleID];
		const content = computeDiffs(prevArticle.content, article.content, amendment.content);

		gDispatch({ type: "upload", table: "article", id: amendment.articleID, data: { content } });
	    }
	}
	
	setSimParam(gData, gDispatch, "presentAmendmentState", "present");
    }

    // BUTTONS
    const leftButtonList = [];
    const rightButtonList = [];

    // PRESENT AMENDMENT
    if (gData.admin && getSimParam(gData, "presentAmendment") && getSimParam(gData, "presentAmendmentState") === "present" && amendmentState === "submitted")
    {
	leftButtonList.push(<Button key="unpresentAmendment" variant="outline-secondary" size="md" onClick={handleUnpresentAmendment}>Suspendre la présentation</Button>)
	rightButtonList.push(<Button key="voteAmendment" variant="primary" size="md" onClick={handleVoteAmendment}>Lancer le vote</Button>);
    }

    // SKIP AMENDMENT
    /* else if (gData.admin && getSimParam(gData, "presentAmendment") && getSimParam(gData, "presentAmendmentState") === "present" && amendmentState === "submitted" && ! canPresentAmendment)
     * {
       leftButtonList.push(<Button key="unpresentAmendment" variant="outline-secondary" size="md" onClick={handleUnpresentAmendment}>Suspendre la présentation</Button>);
       rightButtonList.push(<Button key="nextAmendment" variant="primary" size="md" onClick={handleNextAmendment}>Amendement suivant</Button>);
     * } */

    // VOTE AMENDMENT
    else if (gData.admin && getSimParam(gData, "presentAmendment") && getSimParam(gData, "presentAmendmentState") === "vote")
    {
	leftButtonList.push(<Button key="unvoteAmendment" variant="outline-secondary" size="md" onClick={handleUnvoteAmendment}>Suspendre le vote</Button>);
	rightButtonList.push(<Button key="resultAmendment" variant="primary" size="md" onClick={handleResultAmendment}>Clore le vote</Button>);
    }

    // RESULT AMENDMENT
    else if (gData.admin && getSimParam(gData, "presentAmendment") && getSimParam(gData, "presentAmendmentState") === "result")
    {
	leftButtonList.push(<Button key="voteAmendment" variant="outline-secondary" size="md" onClick={handleVoteAmendment}>Reprendre le vote</Button>);
	rightButtonList.push(<Button key="endorseAmendment" variant="primary" size="md" onClick={handleEndorseAmendment}>Enteriner le vote</Button>);
    }

    // CLOSE
    else if (gData.admin && getSimParam(gData, "presentAmendment") && getSimParam(gData, "presentAmendmentState") === "present" && amendmentState !== "submitted")
    {
	rightButtonList.push(<Button key="unpresentAmendment" variant="primary" size="md" onClick={handleUnpresentAmendment}>Fermer</Button>)
    }

    
    // RENDER
    const modalTitle = amendmentType === "editArticle" ? "Présentation d'un amendement" : "Présentation d'un nouvel article";
    
    return (
	<>
	    <Modal
		size="lg"
		      show={amendmentID !== null}
		      backdrop="static"
		      keyboard={false}
		      centered
	    >
		<Modal.Header>
		    <Modal.Title>{modalTitle}</Modal.Title>
		</Modal.Header>
		<Modal.Body className="d-flex flex-column gap-2">
		    <AmendmentCard amendmentID={amendmentID} footer={false} present={true}/>
		</Modal.Body>

		{(leftButtonList.length > 0 || rightButtonList.length > 0) && (
		    <Modal.Footer>
			<ButtonGrid>
			    <ButtonGrid.Left>{leftButtonList}</ButtonGrid.Left>
			    <ButtonGrid.Right>{rightButtonList}</ButtonGrid.Right>
			</ButtonGrid>
		    </Modal.Footer>
		)}

	    </Modal>
	</>
    );
}
